export default "__VITE_ASSET__42d2b3d5__"